module.exports = __webpack_public_path__ + "img/N2.326370ba.png";